export type ApiMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

export interface ApiError {
  message: string
  status: number
  code?: string
  data?: unknown
}

export class ApiRequestError extends Error implements ApiError {
  status: number
  code?: string
  data?: unknown

  constructor(error: ApiError) {
    super(error.message)
    this.name = 'ApiRequestError'
    this.status = error.status
    this.code = error.code
    this.data = error.data
  }
}

export interface ApiTransportRequest {
  method: ApiMethod
  endpoint: string
  params?: Record<string, unknown>
  data?: unknown
  options?: RequestInit
}

export interface ApiTransport {
  request<T>(request: ApiTransportRequest): Promise<T>
}